import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/home/Navbar';
import { HeroSection } from '../components/home/HeroSection';
import { AboutSection } from '../components/home/AboutSection';
import { BoothShowcase } from '../components/home/BoothShowcase';
import { PackagesSection } from '../components/home/PackagesSection';
import { GallerySection } from '../components/home/GallerySection';
import { InstagramSection } from '../components/home/InstagramSection';
import { ContactSection } from '../components/home/ContactSection';
import { Footer } from '../components/home/Footer';

const Home = () => {
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBooking = () => navigate('/booking');

  return (
    <div className="min-h-screen bg-[#F5F1E8]" data-testid="home-page">
      <Navbar scrollY={scrollY} scrollToBooking={scrollToBooking} />
      <HeroSection scrollToBooking={scrollToBooking} />
      <AboutSection />
      <BoothShowcase />
      <PackagesSection scrollToBooking={scrollToBooking} />
      <GallerySection />
      <InstagramSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
